export default function Features({ featureData }) {
    if (!featureData.length) return null;
    return (
        <div className="feature-grid-section">
            <h3 className="tab-section-txt">FEATURES: </h3>
            <div className="feature-grid">
                {featureData.map((item, index) =>
                    <div className="card-non" key={index}>
                        <img
                            src={item.media}
                            alt={item.title || "Feature image"}
                            loading="lazy"
                            decoding="async"
                        />
                        <p className="semi-txt">
                            {item.title}
                            <br />
                            <span className="sub-text-semi">
                                {item.content}
                            </span>
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}
